module.exports = __webpack_public_path__ + "static/media/air-flap-4.c75dbd28.png";